import { render } from "./OrderComponent.vue?vue&type=template&id=ffb3585c&ts=true"
import script from "./OrderComponent.vue?vue&type=script&lang=ts"
export * from "./OrderComponent.vue?vue&type=script&lang=ts"

import "./OrderComponent.vue?vue&type=style&index=0&id=ffb3585c&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__